import moment from 'moment'
import { Box, Card, CardContent, Grid, Typography } from '@mui/material'
import { BankReconciliationSummaryProps } from '../../../interfaceTypes/props'
import { formatCurrency } from '../../../utils'

const BankReconciliationSummaryCards = ({ reconciliation }: BankReconciliationSummaryProps) => {
  const { beginningBalance, clearedBalance, statementBalance, difference, payments, startDate, endDate, account } =
    reconciliation

  const totalDebits =
    payments?.reduce((total, payment) => {
      return payment.paymentType === 'DEBIT' ? total + payment.amount : total
    }, 0) || 0

  const totalCredits =
    payments?.reduce((total, payment) => {
      return payment.paymentType === 'CREDIT' ? total + payment.amount : total
    }, 0) || 0

  return (
    <Card sx={{ p: 3, mb: 3 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12} textAlign="center">
          <Typography variant="h6">Helmer, Conley & Kasselman, P.A.</Typography>
          <Typography variant="h6" gutterBottom>
            Bank Reconciliation for Bank #{account.sortCode} {account.name}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card variant="outlined" sx={{ height: '100%', '@media print': { width: '60% !important' } }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography color="textSecondary" fontWeight="600">
                  Bank Statement Date
                </Typography>
                <Typography>
                  {moment(startDate).format('MMM D, YYYY')} ⇢ {moment(endDate).format('MMM D, YYYY')}
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography color="textSecondary" fontWeight="600">
                  Statement Balance
                </Typography>
                <Typography>{formatCurrency(statementBalance)}</Typography>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography color="textSecondary" fontWeight="600">
                  Account Beginning Balance
                </Typography>
                <Typography>{formatCurrency(beginningBalance)}</Typography>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography color="textSecondary" fontWeight="600">
                  Cleared Balance
                </Typography>
                <Typography>{formatCurrency(clearedBalance)}</Typography>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography color="textSecondary" fontWeight="600">
                  Total Credits
                </Typography>
                <Typography>{formatCurrency(totalCredits)}</Typography>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography color="textSecondary" fontWeight="600">
                  Total Debits
                </Typography>
                <Typography color="success.main">{formatCurrency(totalDebits)}</Typography>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'space-between', bgcolor: '#f5f5f5', p: 1 }}>
                <Typography color="textSecondary" fontWeight="600">
                  Difference
                </Typography>
                <Typography>{formatCurrency(difference)}</Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Card>
  )
}

export default BankReconciliationSummaryCards
